import { Component, OnInit, Input } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EditorService } from "../../../editor.service";
import { Book } from '../../../../../shared/models/book';
@Component({
  selector: 'app-truefalsequestion',
  templateUrl: './truefalsequestion.component.html',
  styleUrls: ['./truefalsequestion.component.css']
})
export class TruefalsequestionComponent implements OnInit {
  @Input() data: any;
  textImageData;
  public bookObj: Book;
  selectedImage1;
  selectedImage2;
  trueFalseImageData;
  constructor(private http: HttpClient, private editorService: EditorService) { }
  selectCurrentOpt = true;
  istrueFalseMedia = true;
  selectedOption = 0;
  googleTFImageData;
  selectCurrentAnsOpt = true;
  selectCurrentAnsOpt2 = true;
  firstOption = "true";
  secondOption = "false";
  ngOnInit() {
    this.bookObj = this.data.popupProps.curComp.bookObj;
    let cardData = this.editorService.textInlineData;
    if (cardData && cardData.type == "TrueFalse") {
      this.textImageData = cardData;
      this.initializeData(cardData)
    }
  }
  initializeData(data) {
    console.log(data);
    if (data.allOptions[0].isValid) {
      this.selectCurrentOpt = true;
    } else {
      this.selectCurrentOpt = false;
    }
    if (data.allOptions[0].name && data.allOptions[0].type == "Text") {
      this.firstOption = data.allOptions[0].name;
      this.selectCurrentAnsOpt = true;
    }
    if (data.allOptions[1].name && data.allOptions[1].type == "Text") {
      this.secondOption = data.allOptions[1].name;
      this.selectCurrentAnsOpt2 = true;
    }
    if (data.allOptions[0].name && data.allOptions[0].type == "Image") {
      this.selectCurrentAnsOpt = false;
      this.selectedImage1 = data.allOptions[0].name;
    }
    if (data.allOptions[1].name && data.allOptions[1].type == "Image") {
      this.selectedImage2 = data.allOptions[1].name;
      this.selectCurrentAnsOpt2 = false;
    }

  }


  //For updating the true false for true/false
  updateTruefalse(ind) {
    // if (ind == 0) {
    //   this.firstOption = msg.innerText;
    // } else {
    //   this.secondOption = msg.innerText;
    // }
    this.updateTrueFalseQuestion();
  }

  selectTrueFalseOpt(ind) {
    this.selectedOption = ind;
    this.updateTrueFalseQuestion();
  }



  switchToImageCon(ind) {
    this.istrueFalseMedia = !this.istrueFalseMedia;
    this.selectCurrentAnsOpt = false;
    this.selectCurrentAnsOpt2 = false;
    let data: any = {};
    if (ind == 0) {
      data.url = this.selectedImage1
    } else {
      data.url = this.selectedImage2
    }
    this.trueFalseImageData = data;
    this.selectedOption = ind;
    document.getElementsByClassName("globalpopup")[0]['style'].height = "400px";
    document.getElementsByClassName("globalpopup")[0]['style'].width = "350px";
  }

  onChnageGimage(img) {
    this.istrueFalseMedia = true;
    if (this.selectedOption == 0) {
      this.selectedImage1 = img.url;
    } else {
      this.selectedImage2 = img.url;
    }
    document.getElementsByClassName("globalpopup")[0]['style'].height = "270px";
    document.getElementsByClassName("globalpopup")[0]['style'].width = "300px";
    let layer = this.editorService.getIframeReference();
    layer.onTrueOrFalseSelectImages(img.url, this.selectedOption);
  }

  updateTrueFalseQuestion() {
    let obj: any = {
      'answerIndex': this.selectedOption,
      'option1': this.firstOption,
      'option2': this.secondOption
    }
    let layer = this.editorService.getIframeReference();
    layer.updateTextQuestionProperties(obj);
  }




  // document.getElementsByClassName("globalpopup")[0]['style'].height = "350px";
  // document.getElementsByClassName("globalpopup")[0]['style'].width = "300px";


}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/question/truefalsequestion/truefalsequestion.component.ts